import { type ViewPageContentType } from '../../view/ViewPageContentWrapper';
import { type MiddlewhereFilter } from '../../../filter/FilterItemManager';
import useSettings from '../../../hooks/useSettings';

import ViewList from '../../view/list/ViewList';
import ViewTable from '../../view/table/ViewTable';
import DetailsSectionWrapper from './DetailsSectionWrapper';

interface DetailsChildrenTabProps {
	module: string;
	storedProcedure?: string;
	content: ViewPageContentType;
	defaultFilters?: MiddlewhereFilter[];
	defaultQuery?: any;
	filters?: MiddlewhereFilter[];
	refresh: boolean;
	updateRefresh: VoidFunction;
}

export default function DetailsChildrenTab(props: DetailsChildrenTabProps) {
	const { settings, t } = useSettings(props.module);

	if (props.content.type === 'list') {
		return (
			<DetailsSectionWrapper
				className="overflow-y-overlay max-h-full"
				classes={{ content: 'h-full flex flex-col overflow-y-overlay' }}
				disablePadding
			>
				<ViewList
					module={props.module}
					storedProcedure={props.storedProcedure}
					itemLayout={props.content.itemLayout}
					defaultFilters={props.defaultFilters}
					defaultQuery={props.defaultQuery}
					filters={props.filters}
					refresh={props.refresh}
					updateRefresh={props.updateRefresh}
				/>
			</DetailsSectionWrapper>
		);
	}

	if (props.content.type === 'table') {
		const columns = props.content.getColumns({ settings, t, updateRefresh: props.updateRefresh });

		return (
			<ViewTable
				module={props.module}
				query={{ storedProcedure: props.storedProcedure }}
				columns={columns}
				defaultFilters={props.defaultFilters}
				defaultQuery={props.defaultQuery}
				filters={props.filters}
				refresh={props.refresh}
				updateRefresh={props.updateRefresh}
			/>
		);
	}

	return <></>;
}
